import FormatTimeViewModel from './FormatTimeViewModel.js';
export default class PredictViewModel extends FormatTimeViewModel {
  constructor() {
    super();
    this.predict = 0;
  }
}